<template>
  <div class="sign-in-modal" v-if="visible">
    <div class="modal-content">
      <!-- 头部：使用vue-awesome的关闭图标 -->
      <div class="modal-header">
        <h2 class="title">{{ $i18n('dailySignIn', '每日签到') }} <span class="point-text">{{ $i18n('getGift', '领礼品') }}</span></h2>
        <button class="close-btn" @click="close">
          <icon name="times" class="close-icon" />
        </button>
      </div>

      <!-- 核心签到区域 -->
      <div class="sign-in-core">
        <div class="sign-status signed" v-if="hasSignedToday">
          <h3 class="signed-title">{{ $i18n('todaySigned', '今日已签到') }}</h3>
        </div>

        <div class="sign-status unsigned" v-else>
          <button
              class="sign-btn highlight-btn"
              @click="signIn"
              :disabled="isSigning"
          >
            {{ $i18n('signInForGift', '签到领奖') }}
          </button>
        </div>

        <!-- 签到成功打勾动画 -->
        <div class="success-checkmark" v-if="showSuccessCheck">
          <div class="check-icon">
            <!-- 替换为vue-awesome的check图标 -->
            <icon name="check" class="success-icon" />
          </div>
        </div>
      </div>

      <!-- 签到日志：日历签到图标替换 -->
      <div class="checkin-history">
        <h4 class="history-title">本月签到记录</h4>
        <div class="weekdays">
          <span v-for="day in ['日', '一', '二', '三', '四', '五', '六']" :key="day">{{ day }}</span>
        </div>
        <div class="calendar-grid">
          <div
              class="calendar-day"
              v-for="(day, index) in calendarDays"
              :key="index"
              :class="{
              'empty': !day,
              'checked-in': day && isCheckedIn(day),
              'today': day && day === today
            }"
          >
            <span v-if="day">{{ day }}</span>
            <icon name="check" class="calendar-check-icon" v-if="day && isCheckedIn(day)" />
          </div>
        </div>
        <div class="checkin-stats">
          <span>本月已签 {{ checkedDaysCount }} 天</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// 导入vue-awesome核心组件和所需图标
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/times' // 关闭图标
import 'vue-awesome/icons/check' // 打勾图标
import i18nMixin from "@/libs/i18nMixin";

export default {
  name: 'SignInModal',
  mixins: [i18nMixin],
  components: {
    Icon // 注册图标组件
  },
  data() {
    return {
      signInHistory: [],
      visible: false,
      today: new Date().getDate(),
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      showSuccessCheck: false,
      isSigning: false
    };
  },
  computed: {
    ...mapGetters(["live"]),
    hasSignedToday() {
      const today = new Date().toISOString().split('T')[0];
      return this.signInHistory.includes(today);
    },
    todayReward() {
      return '商城小礼物';
    },
    calendarDays() {
      const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1).getDay();

      const daysArray = [];
      for (let i = 0; i < firstDayOfMonth; i++) {
        daysArray.push(null);
      }
      for (let i = 1; i <= daysInMonth; i++) {
        daysArray.push(i);
      }

      return daysArray;
    },
    checkedDaysCount() {
      const currentMonthStr = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}`;
      return this.signInHistory.filter(date => date.startsWith(currentMonthStr)).length;
    }
  },
  methods: {
    isCheckedIn(day) {
      const dateStr = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      return this.signInHistory.includes(dateStr);
    },
    signIn() {
      if (this.hasSignedToday || this.isSigning) return;
      this.isSigning = true;
      this.$http.get(`/signAct/sign?id=${this.live.id}`).then(()=>{
        this.showSignSuccess();
      })
    },
    showSignSuccess() {
      this.$emit('signed');
      // alert(`${this.$i18n('check-in-Successful', '签到成功！获得')}${this.todayReward}`);
      this.$toast.success(`${this.$i18n('check-in-Successful', '签到成功！获得')}${this.todayReward}`);
      this.showSuccessCheck = false;
      this.isSigning = false;
      setTimeout(() => this.close(), 1500);
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.$emit('close');
    },
    getSignInData(){
      this.$http.get(`/signAct/querySignList?id=${this.live.id}`).then(res=>{
        this.signInHistory = res.data.map(item => item.signTime);
      })
    }
  },
  created() {
    this.getSignInData();
  }
};
</script>

<style scoped>
/* 原有样式保持不变，新增/修改图标相关样式 */
/* 关闭图标样式 */
.close-icon {
  font-size: 16px;
  color: #999;
  transition: all 0.2s;
}

.close-btn:hover .close-icon {
  color: #495057;
}

/* 签到成功图标样式 */
.success-icon {
  font-size: 40px;
  color: #28C76F;
  animation: checkBounce 0.6s ease;
}

/* 日历签到图标样式 */
.calendar-check-icon {
  position: absolute;
  bottom: 1px;
  right: 1px;
  font-size: 6px;
  color: white;
  background-color: #28C76F;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 新增图标弹跳动画 */
@keyframes checkBounce {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

/* 简化打勾动画容器样式 */
.success-checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.check-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(40, 199, 111, 0.2);
  background-color: white;
  animation: pulse 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

/* 原有动画及其他样式保持不变 */
@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* 以下为原有样式，保持不变 */
.sign-in-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.modal-content {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 350px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  animation: modalPopIn 0.3s ease;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.title {
  font-size: 15px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  letter-spacing: 0.3px;
}

.title .point-text {
  font-size: 12px;
  font-weight: 700;
  color: #5d6970;
  margin-left: 8px;
  letter-spacing: 0.5px;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.close-btn:hover {
  background-color: #e9ecef;
}

.sign-in-core {
  padding: 2px 16px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  min-height: 80px;
}

.sign-status.signed {
  padding: 2px 0;
}

.signed-title {
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  margin: 0;
}

.sign-status.unsigned {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding: 2px 0;
}

.sign-btn.highlight-btn {
  background: #28C76F;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(40, 199, 111, 0.3);
  transition: all 0.2s ease;
}

.sign-btn.highlight-btn:hover {
  background: #1ba856;
  box-shadow: 0 4px 12px rgba(40, 199, 111, 0.4);
  transform: translateY(-1px);
}

.sign-btn.highlight-btn:disabled {
  background: #a3e6c1;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.checkin-history {
  padding: 10px 16px 12px;
}

.history-title {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.history-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 14px;
  background-color: #28C76F;
  border-radius: 2px;
}

.weekdays {
  display: flex;
  margin-bottom: 4px;
}

.weekdays span {
  flex: 1;
  text-align: center;
  font-size: 10px;
  color: #868e96;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 3px;
  margin-bottom: 6px;
}

.calendar-day {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 12px;
  position: relative;
  margin: 0 auto;
  transition: all 0.15s ease;
}

.calendar-day.empty {
  background-color: #f5f5f5;
  opacity: 0.7;
}

.calendar-day.checked-in {
  background-color: #e8f8ef;
  color: #28C76F;
  font-weight: 600;
}

.calendar-day.today {
  border: 1.5px solid #28C76F;
  color: #28C76F;
  font-weight: 600;
}

.calendar-day:not(.empty):hover {
  transform: scale(1.05);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.checkin-stats {
  font-size: 12px;
  color: #6c757d;
  text-align: center;
  padding-top: 4px;
  border-top: 1px dashed #e9ecef;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes modalPopIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 320px) {
  .sign-in-core {
    padding: 2px 12px 4px;
  }

  .sign-btn.highlight-btn {
    padding: 7px 20px;
    font-size: 14px;
  }

  .calendar-grid {
    gap: 2px;
  }

  .calendar-day {
    width: 24px;
    height: 24px;
    font-size: 11px;
  }

  .calendar-check-icon {
    width: 6px;
    height: 6px;
    font-size: 4px;
  }

  .check-icon {
    width: 60px;
    height: 60px;
  }

  .success-icon {
    font-size: 30px;
  }
}
</style>
